// extracted by mini-css-extract-plugin
export default {"wrap":"Loader_wrap__-0wjy","loader":"Loader_loader__uy4ge"};